import {ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation} from '@angular/core';
import {BreadcrumbService} from "xng-breadcrumb";
import {ActivatedRoute, NavigationEnd, Router} from "@angular/router";
import {Globals} from "../../globals";
import {ListingBrowseService} from "./listing-browse.service";
import {environment} from "../../../environments/environment";
import {HttpEventType} from "@angular/common/http";
import {Subject, Subscription, takeUntil} from "rxjs";
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {globalsBrowseFilter, resolveBaseCategory, applyBrowseTaxonomyBreadcrumbs} from '../../shared/listing-route.utils';
import {canonicalBrowseRouterUrl} from '../../routing/legacy-browse-url';
import {itemUrlSegment, itemSellerUrl} from '../../shared/item-url.utils';
import {buildListingFilterParams} from '../../shared/listing-filter.utils';
import {AttributeDefinitionView, AttributeSchemaService} from '../../shared/attribute-schema.service';
import {isDropshipListing} from '../../shared/fulfillment.utils';
import {filterableAttributeFields} from '../../shared/attribute-form-layout.utils';
import {AppConfigService} from '../../shared/app-config.service';
import {ChangeContext, Options} from "@angular-slider/ngx-slider";
import {NavigationTrackerService} from "../../shared/navigation-tracker.service";
import {CompareService} from "../../shared/listing-browse-ui/rightbar/compare/compare.service";
import {getLastToolsSection, promoteToolsSection} from "../../shared/listing-browse-ui/rightbar/browse-tools-mru";
import {TokenStorageService} from "../../_services/token-storage.service";
import {ListingFilterStateService} from "../../shared/listing-filter-state.service";
import {BrowseKeywordService} from '../../shared/browse-keyword.service';
import {BrowseHistoryService} from '../../shared/browse-history.service';
import {listingThumbnailUrl} from '../../shared/listing-image.utils';
import {AnalyticsBeaconService} from '../../shared/analytics-beacon.service';
import {SeoService} from '../../shared/seo.service';
import {
  browsePathSegments,
  buildBrowseSeoMeta,
  formatBrowseSegmentLabel,
} from '../../shared/browse-seo.utils';

@Component({
  standalone: false,
  selector: 'app-listing-browse',
  templateUrl: './listing-browse.component.html',
  styleUrls: [
    '../../shared/listing-browse-ui/ngslider.scss',
    '../../shared/listing-browse-ui/mat-checkbox.scss',
    './listing-browse.component.scss',
  ],
  encapsulation: ViewEncapsulation.None
})
export class ListingBrowseComponent implements OnInit, OnDestroy {
  private readonly STORAGE_KEY = 'listing_form_values';
  private readonly RIGHT_SIDEBAR_UI_KEY = 'browse_right_sidebar_ui';
  private readonly FILTER_SECTIONS_KEY = 'browse_filter_sections_v2';
  /** Closed by default so listings get the width; rail icons open Filters/Tools. */
  rightSidebarOpen = false;
  /** Which panel the right sidebar shows when open. */
  rightSidebarMode: 'filters' | 'tools' = 'filters';
  filterSectionOpen: Record<string, boolean> = {
    basics: true,
    attributes: false,
  };
  private filterSectionTouched: Record<string, boolean> = {};
  leftSidebarOpen = false;
  url: string;
  urls: string[];
  itemsShop: any = [];
  itemsShopList: any = [];
  urlList;
  environment: any;
  imageSrc: any;
  counties;
  itemsShopCopy: any;
  breadcrumb: string[] = [];
  breadcrumbs: any;
  finalBreadcrumb: any;
  in_itemsShop: any;
  home: string = 'home';
  category: string = 'category';
  subcategory: string = 'subcategory';
  selectedLocation: string = 'All';
  private allowLocationRestore = false;
  categories: string[] = [];
  subcategories: string[] = [];
  urlName: string = '';
  subUrlName: string = '';
  id: any;


  endpoint = '';
  optionss = {
    autoClose: true,
    keepAfterRouteChange: false
  };
  optionsSuccess = {
    autoClose: false,
    keepAfterRouteChange: false
  };
  buffer = '';
  pages: string[] = [];
  page = 1;
  currentPage: number = 0;
  pageSize: number = 20;
  totalCount: any = 0;
  hasMore = true;
  loading = false;

  private unsubscribe$ = new Subject<void>();


  priceValue: number = 0;
  priceHighValue: number = 150000;
  priceOptions = this.setOptions(this.priceValue, this.priceHighValue, 1000);
  text = '   ';


  savedFilters: any[] = [];
  recentSearches: any[] = [];
  compareItems: any[] = [];
  avgPriceRange: {avgPrice: number; minPrice: number; maxPrice: number; priceRange: number} = {
    avgPrice: 0,
    minPrice: 0,
    maxPrice: 0,
    priceRange: 0,
  };
  private readonly SAVED_FILTERS_KEY = 'browse_saved_filters';
  private historySub?: Subscription;
  listingPhotoUrl(photo: string | null | undefined): string {
    return listingThumbnailUrl(this.imageSrc, photo);
  }

  /** Up to 4 attribute display chips for browse cards (category-agnostic). */
  cardAttributeHighlights(row: {attributes?: Array<{displayValue?: string}>}): string[] {
    const attributes = row?.attributes || [];
    const chips: string[] = [];
    for (const attribute of attributes) {
      const text = `${attribute?.displayValue || ''}`.trim();
      if (!text) {
        continue;
      }
      chips.push(text.toUpperCase());
      if (chips.length >= 4) {
        break;
      }
    }
    return chips;
  }

  primaryAttributeHighlight(row: {attributes?: Array<{displayValue?: string}>}): string | null {
    const chips = this.cardAttributeHighlights(row);
    return chips.length ? chips[0] : null;
  }

  isDropshipRow(row: {attributes?: Array<{code?: string; value?: unknown; displayValue?: string}>}): boolean {
    return isDropshipListing(row?.attributes as any);
  }

  private trackListingImpressions(rows: any[] | null | undefined): void {
    if (!rows?.length) {
      return;
    }
    const ids = rows.map(row => row?.item?.itemId ?? row?.itemId);
    this.analyticsBeacon.recordImpressions(ids);
  }

  addToCompare(item: any) {
    if (this.compareItems.length >= 3 || this.isInCompare(item)) {
      return;
    }
    // New array reference so Tools rightbar ngOnChanges can open the Compare section.
    this.compareItems = [
      ...this.compareItems,
      {
        id: item.itemId,
        name: item.name,
        price: item.value,
        image: this.listingPhotoUrl(item.photo)
      }
    ];
    this.compareService.setCompareItems(this.compareItems);
    this.openRightSidebar('tools');
  }

  removeFromCompare(item: any) {
    const id = item?.id ?? item?.itemId;
    this.compareItems = this.compareItems.filter(c => c.id !== id);
    this.compareService.setCompareItems(this.compareItems);
  }

  isInCompare(item: any): boolean {
    return this.compareItems.some(c => c.id === item.itemId);
  }

  onCompareStarted() {
    this.compareService.setCompareItems(this.compareItems);
    this.compareService.markCompareUsed();
    void this.router.navigate(['/compare']);
  }

  getFilters() {
    this.savedFilters = this.readSavedFilters();
  }

  onFilterApplied(filter: any) {
    const next = this.savedFilterToListingFilter(filter);
    this.globals.listingFilter = {
      ...this.globals.listingFilter,
      ...next,
      page: 1,
      size: this.pageSize,
    };
    this.setFormValuesFromFilter();
    this.restoreUIFromFilters();
    this.loadListings(false);
  }

  onFilterSaved() {
    this.persistCurrentFiltersAsSaved();
  }

  onDeleteFilter(filter: any) {
    const id = filter?.id;
    this.savedFilters = (this.savedFilters || []).filter((f: any) => {
      if (id) {
        return f.id !== id;
      }
      return f !== filter;
    });
    this.writeSavedFilters(this.savedFilters);
  }

  private readSavedFilters(): any[] {
    try {
      const raw = localStorage.getItem(this.SAVED_FILTERS_KEY);
      if (!raw) {
        return [];
      }
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  private writeSavedFilters(filters: any[]): void {
    try {
      localStorage.setItem(this.SAVED_FILTERS_KEY, JSON.stringify(filters || []));
    } catch {
      // ignore quota
    }
  }

  private persistCurrentFiltersAsSaved(): void {
    const params = this.listingFilterParams();
    const searchFilters = this.browseHistory.extractSearchFilters(this.globals.listingFilter as Record<string, unknown>);
    const summary = searchFilters
      ? this.browseHistory.summarizeSearchFilters(searchFilters)
      : (params['subcategory'] || params['category'] || 'Saved filter');
    const entry = {
      id: `sf_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
      summary: `${summary}`,
      savedAt: new Date().toISOString(),
      selected: false,
      ...params,
    };
    this.savedFilters = [entry, ...(this.savedFilters || [])].slice(0, 20);
    this.writeSavedFilters(this.savedFilters);
    promoteToolsSection('saved');
  }

  private savedFilterToListingFilter(filter: any): Record<string, unknown> {
    if (!filter || typeof filter !== 'object') {
      return {};
    }
    const skip = new Set(['id', 'summary', 'savedAt', 'selected', 'paramId', 'make', 'model',
      'minYear', 'maxYear', 'fuelType', 'bodyType', 'driveType', 'minEng', 'maxEng',
      'minKm', 'maxKm', 'transmission', 'entityType']);
    const next: Record<string, unknown> = {attributes: {}};
    for (const [key, value] of Object.entries(filter)) {
      if (skip.has(key)) {
        continue;
      }
      next[key] = value;
    }
    if (!next.attributes || typeof next.attributes !== 'object') {
      next.attributes = {};
    }
    return next;
  }

  private pendingScrollItemId: string | null = null;
  private listingUrl: string | null = null;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private token: TokenStorageService,
              private breadcrumbService: BreadcrumbService,
              private allService: ListingBrowseService,
              public globals: Globals,
              private compareService: CompareService,
              private navigationTracker: NavigationTrackerService,
              private cdr: ChangeDetectorRef,
              private filterState: ListingFilterStateService,
              private attributeSchemaService: AttributeSchemaService,
              private appConfigService: AppConfigService,
              private browseKeywordService: BrowseKeywordService,
              private browseHistory: BrowseHistoryService,
              private analyticsBeacon: AnalyticsBeaconService,
              private seoService: SeoService) {
    environment.then(environment => {
      this.environment = environment;
      this.url = environment["backendURL"];
      this.imageSrc = environment["images"];
      this.recentlyViewed = this.browseHistory.recentlyViewed.map(entry => ({
        ...entry,
        photoUrl: listingThumbnailUrl(this.imageSrc, entry.photo),
      }));
    });

    // Only reset if NOT coming from all-motor-item
    if (!this.navigationTracker.getIsFromListingDetail()) {
      this.selectedLocation = 'All';
      this.globals.listingFilter.location = null;
      this.globals.location = null;
    }
  }

  sortBy: string = 'latest';

  onSortChange(value: string) {
    switch(value) {
      case 'price-low':
        this.globals.listingFilter.orderBy = ' ORDER BY e.value ASC';
        break;
      case 'price-high':
        this.globals.listingFilter.orderBy = ' ORDER BY e.value DESC';
        break;
      default:
        this.globals.listingFilter.orderBy = ' ORDER BY e.createdOn DESC';
    }
    this.loadListings(false);
  }

  private addToRecentSearches() {
    this.browseHistory.recordSearch(this.globals.listingFilter as Record<string, unknown>);
    this.recentSearches = this.browseHistory.recentSearches;
  }

  onSearchApplied(search: any) {
    promoteToolsSection('searches');
    const filters = search?.filters || {};
    this.globals.listingFilter.keyword = filters.keyword ?? null;
    this.globals.listingFilter.location = filters.location ?? null;
    this.globals.listingFilter.minPrice = filters.minPrice ?? null;
    this.globals.listingFilter.maxPrice = filters.maxPrice ?? null;
    this.globals.listingFilter.attributes = {...(filters.attributes || {})};
    this.globals.listingFilter.page = 1;
    this.setFormValuesFromFilter();
    this.restoreUIFromFilters();
    this.loadListings(false);
  }

  onRecentViewedClicked(item: any) {
    promoteToolsSection('viewed');
    sessionStorage.setItem('fromItemDetail', 'true');
    if (Array.isArray(item?.route) && item.route.length >= 2) {
      void this.router.navigate(item.route);
      return;
    }
    const route = this.browseHistory.buildItemRoute(item, this.urls);
    if (route.length >= 2) {
      void this.router.navigate(route);
    }
  }

  // Stop the streaming on component destroy
  ngOnDestroy(): void {
    // Unsubscribe from the stream when the user navigates away
    this.unsubscribe$.next();
    this.unsubscribe$.complete();

    // Save form state to localStorage before leaving
    this.saveFormState();
    this.persistRightSidebarUi();
    this.historySub?.unsubscribe();
    this.seoService.clearBrowsePage();
  }
  recentlyViewed: any[] = [];

  hasMoreItems = true;
  displayedItems = 20;

  loadMore() {
    this.displayedItems += 20;
    if (this.displayedItems >= this.totalCount) {
      this.hasMoreItems = false;
    }
  }


  ngOnInit(): void {
    const browseCanonical = canonicalBrowseRouterUrl(this.router.url);
    if (browseCanonical) {
      void this.router.navigateByUrl(browseCanonical, {replaceUrl: true});
      return;
    }

    this.restoreRightSidebarUi();
    this.restoreFilterSectionState();
    this.compareItems = this.compareService.getCompareItems() || [];
    this.recentlyViewed = this.browseHistory.recentlyViewed.map(entry => ({
      ...entry,
      photoUrl: listingThumbnailUrl(this.imageSrc, entry.photo),
    }));
    this.recentSearches = this.browseHistory.recentSearches;

    const fromItemDetail = sessionStorage.getItem('fromItemDetail');
    const lastToolsSection = getLastToolsSection();
    // Returning from a listing: Recently Viewed is the latest Tools action.
    if (fromItemDetail) {
      promoteToolsSection('viewed');
      this.openRightSidebar('tools');
    } else if (lastToolsSection === 'compare' && this.compareItems.length > 0) {
      this.openRightSidebar('tools');
    }

    if (!fromItemDetail) {
      localStorage.removeItem('listing_filter_state');
      localStorage.removeItem('listing_ui_state');
    }

    this.keywordSearch$.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      takeUntil(this.unsubscribe$)
    ).subscribe(value => {
      const trimmed = (value ?? '').trim();
      this.globals.listingFilter.keyword = trimmed || null;
      if (!this.isRestoring) {
        this.loadListings(false);
      }
    });

    this.browseKeywordService.applied.pipe(takeUntil(this.unsubscribe$)).subscribe(value => {
      this.searchKeyword = value ?? '';
      this.globals.listingFilter.keyword = this.searchKeyword.trim() || null;
      if (!this.isRestoring) {
        this.loadListings(false);
      }
    });

    this.globals.selectedFilter = true;

    if (this.token.getUser()) {
      this.globals.listingFilter.username = this.token.getUser().username;
    }

    this.historySub = new Subscription();
    this.historySub.add(this.browseHistory.recentlyViewed$.subscribe(entries => {
      this.recentlyViewed = entries.map(entry => ({
        ...entry,
        photoUrl: listingThumbnailUrl(this.imageSrc, entry.photo),
      }));
    }));
    this.historySub.add(this.browseHistory.recentSearches$.subscribe(entries => {
      this.recentSearches = entries;
    }));
    this.recentlyViewed = this.browseHistory.recentlyViewed.map(entry => ({
      ...entry,
      photoUrl: listingThumbnailUrl(this.imageSrc, entry.photo),
    }));
    this.recentSearches = this.browseHistory.recentSearches;

    this.getFilters();

    this.globals.listingFilter.profile = null;
    this.globals.listingFilter.category = resolveBaseCategory(this.router.url.split('/').filter(element => element));
    console.log(this.globals.listingFilter.category);
    this.globals.listingFilter.subcategory = null;
    this.globals.listingFilter.subSubcategory = null;
    this.globals.listingFilter.subSubSubcategory = null;
    this.globals.listingFilter.subSubSubSubcategory = null;
    this.globals.listingFilter.subSubSubSubSubcategory = null;
    this.globals.listingFilter.subSubSubSubSubSubcategory = null;
    this.globals.listingFilter.subSubSubSubSubSubSubcategory = null;
    this.globals.listingFilter.subSubSubSubSubSubSubSubcategory = null;

    this.urls = this.router.url.split('/').filter(element => element);
    this.urlName = globalsBrowseFilter(this.urls, this.globals);
    this.listingUrl = this.router.url;

    this.setBreadcrumb();
    this.globals.listingFilter.page = 1;
    this.globals.listingFilter.pageSize = 100;
    this.globals.listingFilter.totalCount = null;

    const savedItemId = sessionStorage.getItem('motor_scroll_item_id');

    if (fromItemDetail) {
      sessionStorage.removeItem('fromItemDetail');
      if (savedItemId) {
        this.pendingScrollItemId = savedItemId;
      }
      sessionStorage.removeItem('motor_scroll_item_id');
      sessionStorage.removeItem('motor_current_page');
      sessionStorage.removeItem('motor_items_count');
      sessionStorage.removeItem('listing_filter_state');
      sessionStorage.removeItem('displayedItems');
      sessionStorage.removeItem('scrollToItemId');
      this.navigationTracker.reset();
    }

    this.getBasicFilter(true);
    this.sortSideBar();
    this.loadListings(false);

    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe(event => {
      if (event instanceof NavigationEnd) {
        const path = event.urlAfterRedirects || event.url;
        if (!path.includes('/all')) {
          return;
        }
        if (path === this.listingUrl) {
          return;
        }
        this.listingUrl = path;
        this.urls = path.split('/').filter(segment => segment);
        this.urlName = globalsBrowseFilter(this.urls, this.globals);
        this.setBreadcrumb();
        this.loadAttributeFilterSchema();
        this.sortSideBar();
        if (this.itemsShopList.length === 0 && !this.loading) {
          this.loadListings(false);
        }
      }
    });

    this.allService.getCounties(this.url, '/counties').subscribe(response => {
      this.counties = response;
      this.counties.push('ALL');
      this.counties.sort((a, b) => a.localeCompare(b));
    });
  }

  private restoreUIFromFilters() {
    this.priceValue = this.globals.listingFilter.minPrice ? Number(this.globals.listingFilter.minPrice) : 0;
    this.priceHighValue = this.globals.listingFilter.maxPrice ? Number(this.globals.listingFilter.maxPrice) : 150000;
    this.selectedLocation = this.globals.listingFilter.location || 'All';
    this.searchKeyword = this.globals.listingFilter.keyword || '';
  }

  private isRestoring = false;

  private restoreScrollState(itemId: string, lastPage: number, totalLoaded: number) {
    this.isRestoring = true;
    this.loading = true;
    this.itemsShopList = [];

    const loadPage = (page: number) => {
      this.globals.listingFilter.page = page;
      this.globals.listingFilter.size = this.pageSize;
      return this.allService.getWithDataHeader(this.url + this.searchEndpoint, this.listingFilterParams()).toPromise();
    };

    const requests = [];
    for (let i = 0; i <= lastPage; i++) {
      requests.push(loadPage(i));
    }

    Promise.all(requests).then(responses => {
      this.itemsShopList = responses.flatMap(r => r.items || []);
      this.trackListingImpressions(this.itemsShopList);
      this.currentPage = lastPage;
      this.totalCount = responses[0]?.totalCount || 0;
      this.hasMore = responses[lastPage]?.hasMore || false;
      this.loading = false;
      this.applyBrowseSeo();

      this.cdr.detectChanges();

      setTimeout(() => {
        this.scrollToItem(itemId, 0);

        setTimeout(() => {
          this.getBasicFilter(false);
          this.isRestoring = false;
        }, 1000);
      }, 100);

      setTimeout(() => {
        sessionStorage.removeItem('motor_scroll_item_id');
        sessionStorage.removeItem('motor_current_page');
        sessionStorage.removeItem('motor_items_count');
        sessionStorage.removeItem('listing_filter_state');
      }, 2000);
    }).catch(err => {
      console.error('Restore failed:', err);
      this.loading = false;
      this.isRestoring = false;
      this.loadListings(false);
    });

  }

  private scrollToItem(itemId: string, attempt: number) {
    if (attempt > 5) {
      console.warn('Failed to scroll to item after 5 attempts');
      return;
    }

    const delay = attempt === 0 ? 500 : 500 * attempt;

    setTimeout(() => {
      const element = document.getElementById('item-' + itemId);
      const scrollContainer = document.querySelector('.scrollable-content');

      if (element && scrollContainer) {
        console.log('Found element, scrolling within container...');

        // Calculate position relative to container
        const elementTop = element.offsetTop;
        const containerTop = scrollContainer.scrollTop;
        const offset = 275; // Space from top

        scrollContainer.scrollTo({
          top: elementTop - offset,
          behavior: 'smooth'
        });
      } else {
        if (attempt === 1) {
          console.log('Container found:', !!scrollContainer);
          console.log('Element found:', !!element);
        }
        console.log('Element not found, retrying...', attempt + 1);
        this.scrollToItem(itemId, attempt + 1);
      }
    }, delay);
  }

  addToRecentlyViewed(item: any) {
    if (!item) {
      return;
    }
    this.browseHistory.recordViewed(item, this.urls);
  }

  saveScrollState(item: any) {
    if (item?.item) {
      this.addToRecentlyViewed(item.item);
    }
    sessionStorage.setItem('fromItemDetail', 'true');
    sessionStorage.setItem('motor_scroll_item_id', item.item.itemId);
    sessionStorage.setItem('motor_current_page', this.currentPage.toString());
    sessionStorage.setItem('motor_items_count', this.itemsShopList.length.toString());
    sessionStorage.setItem('motor_scroll_position', window.scrollY.toString());
    this.globals.listingFilter.endUser = itemSellerUrl(item.item);
    sessionStorage.setItem('listing_filter_state', JSON.stringify(this.globals.listingFilter));
  }


  buildItemRoute(item: { url?: string; itemId?: string; bc?: any }): string[] {
    return this.browseHistory.buildItemRoute(item, this.urls);
  }

  calculatePriceStats() {
    if (!this.itemsShopList || this.itemsShopList.length === 0) {
      return { avgPrice: 0, minPrice: 0, maxPrice: 0, priceRange: 0 };
    }

    const prices = this.itemsShopList
      .map((item: any) => item.item.value)
      .filter((price: number) => price && price > 0);


    if (prices.length === 0) {
      return { avgPrice: 0, minPrice: 0, maxPrice: 0, priceRange: 0 };
    }

    const minPrice = Math.min(...prices);
    const maxPrice = Math.max(...prices);
    const avgPrice = prices.reduce((sum: number, price: number) => sum + price, 0) / prices.length;
    const priceRange = maxPrice - minPrice;

    return { avgPrice, minPrice, maxPrice, priceRange };
  }

  filterableAttributeSchema: AttributeDefinitionView[] = [];
  searchKeyword = '';
  private keywordSearch$ = new Subject<string>();

  /** Any category listing page (/…/all) should expose listing filters. */
  get showListingFilters(): boolean {
    return true;
  }

  openRightSidebar(mode: 'filters' | 'tools'): void {
    this.rightSidebarMode = mode;
    this.rightSidebarOpen = true;
    this.persistRightSidebarUi();
  }

  closeRightSidebar(): void {
    this.rightSidebarOpen = false;
    this.persistRightSidebarUi();
  }

  setRightSidebarMode(mode: 'filters' | 'tools'): void {
    this.rightSidebarMode = mode;
    this.rightSidebarOpen = true;
    this.persistRightSidebarUi();
  }

  isFilterSectionOpen(id: string): boolean {
    return !!this.filterSectionOpen[id];
  }

  toggleFilterSection(id: string): void {
    this.filterSectionOpen[id] = !this.isFilterSectionOpen(id);
    this.filterSectionTouched[id] = true;
    this.persistFilterSectionState();
  }

  private restoreFilterSectionState(): void {
    try {
      const raw = sessionStorage.getItem(this.FILTER_SECTIONS_KEY);
      const touchedRaw = sessionStorage.getItem(`${this.FILTER_SECTIONS_KEY}_touched`);
      if (touchedRaw) {
        const touched = JSON.parse(touchedRaw);
        if (touched && typeof touched === 'object') {
          this.filterSectionTouched = touched;
        }
      }
      if (raw) {
        const parsed = JSON.parse(raw);
        if (parsed && typeof parsed === 'object') {
          this.filterSectionOpen = {...this.filterSectionOpen, ...parsed};
        }
      }
    } catch {
      // ignore
    }
    this.syncFilterSectionOpenState();
  }

  private persistFilterSectionState(): void {
    try {
      sessionStorage.setItem(this.FILTER_SECTIONS_KEY, JSON.stringify(this.filterSectionOpen));
      sessionStorage.setItem(`${this.FILTER_SECTIONS_KEY}_touched`, JSON.stringify(this.filterSectionTouched));
    } catch {
      // ignore
    }
  }

  private syncFilterSectionOpenState(): void {
    // Price & location always has controls — leave open unless the user closed it.
    if (!this.filterSectionTouched['basics'] && this.filterSectionOpen['basics'] === undefined) {
      this.filterSectionOpen['basics'] = true;
    }
    // Attributes: open only when there are fields to show (and user hasn't overridden).
    if (!this.filterSectionTouched['attributes']) {
      this.filterSectionOpen['attributes'] = (this.filterableAttributeSchema?.length || 0) > 0;
    }
  }

  private restoreRightSidebarUi(): void {
    try {
      const raw = sessionStorage.getItem(this.RIGHT_SIDEBAR_UI_KEY);
      if (!raw) {
        return;
      }
      const parsed = JSON.parse(raw) as {open?: boolean; mode?: string};
      if (typeof parsed.open === 'boolean') {
        this.rightSidebarOpen = parsed.open;
      }
      if (parsed.mode === 'filters' || parsed.mode === 'tools') {
        this.rightSidebarMode = parsed.mode;
      }
    } catch {
      // Ignore corrupt session state.
    }
  }

  private persistRightSidebarUi(): void {
    try {
      sessionStorage.setItem(this.RIGHT_SIDEBAR_UI_KEY, JSON.stringify({
        open: this.rightSidebarOpen,
        mode: this.rightSidebarMode,
      }));
    } catch {
      // Ignore quota / private-mode failures.
    }
  }


private setOptions(floor:any, ceil:any, step: any) : Options{
    let options : Options = {
      floor: floor,
      ceil: ceil,
      step: step,
      translate: (value: number): string => `${value}`
    };

    return options;
  }


  private setBreadcrumb() {
    applyBrowseTaxonomyBreadcrumbs(this.breadcrumbService, this.router.url);
    const urlname = formatBrowseSegmentLabel(this.urlName || '');
    this.applyBrowseSeo(urlname);
  }

  private applyBrowseSeo(leafLabel?: string): void {
    const segments = (this.urls?.length ? this.urls : browsePathSegments(this.router.url))
      .map(s => `${s || ''}`.split(/[?#]/)[0])
      .filter(s => s && s !== 'all');
    const label = (leafLabel || '').trim()
      || formatBrowseSegmentLabel(this.urlName || segments[segments.length - 1] || 'Browse');
    const count = Number(this.totalCount);
    const meta = buildBrowseSeoMeta({
      urlSegments: segments,
      leafLabel: label,
      kind: 'listings',
      listingCount: Number.isFinite(count) && count >= 0 ? count : null,
      pageUrl: typeof window !== 'undefined' ? window.location.href.split('?')[0] : undefined,
    });
    this.seoService.applyBrowsePage(meta);
  }


/*  onPageChange(pageNumber: number) {
    this.currentPage = pageNumber;
    window.scrollTo({top: 0, left: 0, behavior: 'auto'}); // Scroll to top of the page
  }*/

  private getPageCount() {
    // totalCount comes from GET /api/listings/search.
  }

  private lastProcessedLength = 0;

  private tempItemsList: any[] = [];

  /*private loadListings(isRest: boolean) {
    this.unsubscribe$.next();
    this.addToRecentSearches();
    let params = this.listingFilterParams();

    const shouldScroll = !!this.pendingScrollItemId;

    if (!shouldScroll && isRest) {
      this.displayedItems = 20;
    }

    const targetDisplayedItems = shouldScroll ? parseInt(sessionStorage.getItem('displayedItems') || '20') : this.displayedItems;

    this.tempItemsList = [];
    // Don't clear itemsShopList if we're scrolling - prevents flash
    if (!shouldScroll) {
      this.itemsShopList = [];
    }
    this.buffer = '';
    this.lastProcessedLength = 0;

    let scrollAttempted = false;

//     this.allService.getWithDataHeader(this.url + '/motors/search', params).pipe(takeUntil(this.unsubscribe$))
//     this.allService.getWithDataHeader(this.url + '/motors/search', params).pipe(takeUntil(this.unsubscribe$))
      .subscribe(event => {
        if (event.type === HttpEventType.DownloadProgress) {
          const fullText = event.partialText || '';
          const newText = fullText.substring(this.lastProcessedLength);
          this.lastProcessedLength = fullText.length;

          this.buffer += newText;

          let jsonChunks = this.buffer.split("\n");
          this.buffer = jsonChunks.pop() || '';

          jsonChunks.forEach((chunk) => {
            if (chunk.trim()) {
              try {
                let parsedArray: any[] = JSON.parse(chunk);
                this.tempItemsList.push(...parsedArray);
                this.itemsShopList.push(...parsedArray);
                this.trackListingImpressions(parsedArray);

                if (shouldScroll && !scrollAttempted) {
                  const itemIndex = this.itemsShopList.findIndex((item: any) => item.item.itemId === this.pendingScrollItemId);

                  if (itemIndex !== -1) {
                    scrollAttempted = true;
                    this.displayedItems = Math.max(targetDisplayedItems, itemIndex + 1);
                    this.hasMoreItems = this.displayedItems < this.totalCount;
                    this.cdr.detectChanges();

                    setTimeout(() => {
                      const element = document.getElementById('item-' + this.pendingScrollItemId);
                      const scrollContainer = document.querySelector('.scrollable-content');

                      if (element && scrollContainer) {
                        scrollContainer.scrollTo({
                          top: element.offsetTop - 275,
                          behavior: 'smooth'
                        });
                      }

                      this.pendingScrollItemId = null;
                      sessionStorage.removeItem('scrollToItemId');
                      sessionStorage.removeItem('displayedItems');
                    }, 300);
                  }
                }
              } catch (e) {
              }
            }
          });
        }

        if (event.type === HttpEventType.Response) {
          this.avgPriceRange = this.calculatePriceStats();

          if (!shouldScroll) {
            if (isRest) this.displayedItems = 20;
            this.hasMoreItems = this.displayedItems < this.totalCount;
          }
        }
      });
  }*/

  private get searchEndpoint(): string {
    // Canonical browse contract (ItemEntity + attribute filters). Not /motors/search.
    return '/api/listings/search';
  }

  loadListings(loadMore: boolean = false) {
    if (this.isRestoring) {
      return;
    }

    if (this.loading && loadMore) {
      return;
    }

    this.loading = true;
    if (!loadMore) {
      this.currentPage = 0;
      const scrollContainer = document.querySelector('.scrollable-content');
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    }

    this.globals.listingFilter.page = this.currentPage;
    this.globals.listingFilter.size = this.pageSize;
    let params = this.listingFilterParams();

    this.allService.getWithDataHeader(this.url + this.searchEndpoint, params)
      .subscribe({
        next: (response) => {
          if (loadMore) {
            this.itemsShopList = [...this.itemsShopList, ...response.items];
          } else {
            this.itemsShopList = response.items;
          }
          this.trackListingImpressions(response.items);

          this.currentPage = response.currentPage;
          this.totalCount = response.totalCount;
          this.hasMore = response.hasMore;
          this.hasMoreItems = response.hasMore;
          this.avgPriceRange = this.calculatePriceStats();
          this.loading = false;
          this.applyBrowseSeo();
          if (!loadMore) {
            this.browseHistory.recordSearch(this.globals.listingFilter as Record<string, unknown>);
            this.recentSearches = this.browseHistory.recentSearches;
          }

          if (this.pendingScrollItemId) {
            const itemId = this.pendingScrollItemId;
            this.pendingScrollItemId = null;
            setTimeout(() => this.scrollToItem(itemId, 0), 100);
          }
        },
        error: (err) => {
          console.error(err);
          this.loading = false;
          if (!loadMore) {
            this.itemsShopList = [];
            this.totalCount = 0;
            this.avgPriceRange = this.calculatePriceStats();
          }
        }
      });
  }

  onLoadMore() {
    console.log('onLoadMore called - hasMore:', this.hasMore, 'loading:', this.loading);
    if (!this.hasMore || this.loading) {
      console.log('Blocked - hasMore:', this.hasMore, 'loading:', this.loading);
      return;
    }
    this.currentPage++;
    console.log('Incremented to page:', this.currentPage);
    this.loadListings(true);
  }


  onFilterChange() {
    this.currentPage = 0;
    this.loadListings(false);
  }

  onAttributeFilterChange(values: Record<string, string>): void {
    this.globals.listingFilter.attributes = {...values};
    this.onFilterChange();
  }

  clearAttributeFilters(): void {
    this.globals.listingFilter.attributes = {};
    this.onFilterChange();
  }

  get activeAttributeFilterCount(): number {
    const attrs = this.globals.listingFilter?.attributes || {};
    return Object.values(attrs).filter(value => value !== null && value !== undefined && `${value}`.trim() !== '').length;
  }

  get totalActiveFilterCount(): number {
    let count = this.activeAttributeFilterCount;
    if ((this.searchKeyword || '').trim()) {
      count++;
    }
    const location = this.globals.listingFilter?.location;
    if (location && location !== 'All') {
      count++;
    }
    const minPrice = Number(this.globals.listingFilter?.minPrice);
    const maxPrice = Number(this.globals.listingFilter?.maxPrice);
    if (minPrice > 0 || (maxPrice > 0 && maxPrice < 150000)) {
      count++;
    }
    return count;
  }

  onKeywordSearchChange(value: string): void {
    this.searchKeyword = value ?? '';
    this.keywordSearch$.next(this.searchKeyword);
  }


  private getBasicFilter(_isRest: boolean) {
    this.initGenericBasicFilters();
  }

  private initGenericBasicFilters(): void {
    this.selectedLocation = this.globals.listingFilter.location || 'All';
    this.searchKeyword = this.globals.listingFilter.keyword || '';
    this.priceValue = this.globals.listingFilter.minPrice ? Number(this.globals.listingFilter.minPrice) : 0;
    this.priceHighValue = this.globals.listingFilter.maxPrice ? Number(this.globals.listingFilter.maxPrice) : 150000;
    this.priceOptions = Object.assign({}, this.setOptions(0, 150000, 1000));
    if (!this.globals.listingFilter.attributes) {
      this.globals.listingFilter.attributes = {};
    }
    this.loadAttributeFilterSchema();
  }

  private loadAttributeFilterSchema(): void {
    this.appConfigService.attributesEnabled().subscribe(enabled => {
      if (!enabled) {
        this.filterableAttributeSchema = [];
        this.syncFilterSectionOpenState();
        return;
      }
      const categoryPath = this.attributeSchemaService.categoryPathFromListingFilter(
        this.globals.listingFilter as Record<string, unknown>
      );
      this.attributeSchemaService.getSchema(categoryPath).subscribe({
        next: schema => {
          this.filterableAttributeSchema = filterableAttributeFields(schema?.attributes || []);
          this.syncFilterSectionOpenState();
        },
        error: err => {
          console.error('Failed to load attribute filter schema', err);
          this.filterableAttributeSchema = [];
          this.syncFilterSectionOpenState();
        }
      });
    });
  }

  onLocationSelected(value: string): void {
    this.filterState.updateFilter({location: value === 'All' ? null : value});
    this.loadListings(false);
  }


  onPriceSliderStart(changeContext: ChangeContext): void {
    if (changeContext.pointerType === 0) {
      this.globals.listingFilter.orderBy = ' ORDER BY e.value ASC';
    } else if (changeContext.pointerType === 1) {
      this.globals.listingFilter.orderBy = ' ORDER BY e.value DESC';
    }
  }

  onPriceSliderEnd(changeContext: ChangeContext): void {
    this.filterState.updateFilter({
      minPrice: changeContext.value,
      maxPrice: changeContext.highValue,
    });
    this.priceValue = changeContext.value;
    this.priceHighValue = changeContext.highValue;
    this.loadListings(false);
    this.getPageCount();
  }


  showAsList() {
    this.globals.isPanel = false;
    this.globals.isList = true;
  }

  saveFilter() {
    this.persistCurrentFiltersAsSaved();
  }

  showAsPanel() {
    this.globals.isList = false;
    this.globals.isPanel = true;
  }

  private sortSideBar() {
    this.urlList = [];
    if (!this.url) {
      return;
    }
    const params = this.listingFilterParams();
    this.allService.getWithDataHeader(this.url + '/api/browse/sidebar', params).subscribe({
      next: (response) => {
        this.urlList = response || [];
      },
      error: (err) => {
        console.error('Failed to load browse sidebar', err);
        this.urlList = [];
      }
    });
  }


  /**
   * Saves the current form state to localStorage
   */
  private saveFormState(): void {
    this.globals.listingFilter.location = this.selectedLocation === 'All' ? null : this.selectedLocation;
    const formState = {
      listingFilter: {...this.globals.listingFilter},
      selectedFilter: this.globals.selectedFilter,
      selectedLocation: this.selectedLocation,
      searchKeyword: this.searchKeyword,
    };
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(formState));
  }

  private listingFilterParams() {
    return buildListingFilterParams(this.globals.listingFilter as Record<string, unknown>);
  }

  private getMessage() {
    let msg = '';
    if (this.globals.listingFilter.profile) {
      msg += '<br>Profile: ' + this.globals.listingFilter.profile.toUpperCase() + '<br>';
    }
    if (this.globals.listingFilter.keyword) {
      msg += '<br>Keyword: ' + this.globals.listingFilter.keyword + '<br>';
    }
    if (this.globals.listingFilter.subcategory) {
      msg += '<br>Category: ' + this.globals.listingFilter.subcategory.toUpperCase() + '<br>';
    }
    if (this.globals.listingFilter.subSubcategory) {
      msg += '<br>Subcategory: ' + this.globals.listingFilter.subSubcategory.toUpperCase() + '<br>';
    }
    if (this.globals.listingFilter.maxPrice) {
      msg += '<br>Max Price: ' + this.globals.listingFilter.maxPrice + '<br>';
    }
    if (this.globals.listingFilter.minPrice) {
      msg += '<br>Min Price: ' + this.globals.listingFilter.minPrice + ' <br>';
    }
    if (this.globals.listingFilter.location) {
      msg += '<br>Location: ' + this.globals.listingFilter.location.toUpperCase() + ' <br>';
    }
    const attrs = this.globals.listingFilter.attributes || {};
    for (const [code, value] of Object.entries(attrs)) {
      if (value !== null && value !== undefined && `${value}`.trim() !== '') {
        msg += '<br>' + code + ': ' + `${value}`.toUpperCase() + ' <br>';
      }
    }
    return 'No search results found for: <br>' + msg;
  }


  onResetFilters() {
    this.selectedLocation = 'All';
    this.priceValue = 0;
    this.priceHighValue = 150000;
    this.priceOptions = Object.assign({}, this.setOptions(0, 150000, 1000));
    this.resetParams();
    localStorage.removeItem(this.STORAGE_KEY);
    this.loadListings(false);
    this.getBasicFilter(false);
  }

  private resetParams() {
    Object.assign(this.globals.listingFilter, {
      minPrice: null,
      maxPrice: null,
      location: null,
      page: 1,
      keyword: null,
      attributes: {},
      orderBy: null,
    });
    this.searchKeyword = '';
  }

  setFormValuesFromFilter() {
    this.selectedLocation = this.globals.listingFilter.location || 'All';
    this.priceValue = this.globals.listingFilter.minPrice || 0;
    this.priceHighValue = this.globals.listingFilter.maxPrice || 150000;
    this.searchKeyword = this.globals.listingFilter.keyword || '';
  }

}
